(function () {
  if (window.SterntalerSizeFinderInit) return;
  window.SterntalerSizeFinderInit = true;

  function monthsToLabel(months) {
    months = Math.round(months);
    if (months < 12) return months + ' Monate';
    var years = Math.floor(months / 12);
    var rest = months % 12;
    if (rest === 0) return years + (years === 1 ? ' Jahr' : ' Jahre');
    return years + (years === 1 ? ' Jahr ' : ' Jahre ') + rest + ' Monate';
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  function initRoot(root) {
    var step1Buttons = root.querySelectorAll('[data-sf-mode-choice]');
    var panels = root.querySelectorAll('[data-sf-panel]');
    var ageSlider = root.querySelector('[data-sf-age-slider]');
    var ageReadout = root.querySelector('[data-sf-age-readout]');
    var newbornCheckbox = root.querySelector('[data-sf-newborn]');
    var measurementInputs = root.querySelectorAll('[data-sf-measurement-type]');
    var resultsEl = root.querySelector('[data-sf-results]');
    var guideRoots = root.querySelectorAll('[data-sf-guide]');
    var fullToggle = root.querySelector('[data-sf-full-toggle]');
    var fullWrapper = root.querySelector('[data-sf-full]');

    var state = { mode: null };

    function setMode(mode) {
      state.mode = mode;
      step1Buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-sf-mode-choice') === mode);
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-sf-panel') !== mode;
      });
      compute();
    }

    step1Buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMode(btn.getAttribute('data-sf-mode-choice'));
      });
    });

    var debouncedCompute = debounce(compute, 250);

    if (ageSlider) {
      ageSlider.addEventListener('input', function () {
        if (ageReadout) {
          ageReadout.textContent = newbornCheckbox && newbornCheckbox.checked
            ? 'Neugeboren'
            : monthsToLabel(ageSlider.value);
        }
        debouncedCompute();
      });
    }

    if (newbornCheckbox) {
      newbornCheckbox.addEventListener('change', function () {
        if (ageSlider) ageSlider.disabled = newbornCheckbox.checked;
        if (ageReadout) {
          ageReadout.textContent = newbornCheckbox.checked ? 'Neugeboren' : monthsToLabel(ageSlider ? ageSlider.value : 0);
        }
        compute();
      });
    }

    measurementInputs.forEach(function (input) {
      input.addEventListener('input', debouncedCompute);
    });

    if (fullToggle && fullWrapper) {
      fullToggle.addEventListener('click', function () {
        var isHidden = fullWrapper.hasAttribute('hidden');
        if (isHidden) {
          fullWrapper.removeAttribute('hidden');
          fullToggle.textContent = fullToggle.getAttribute('data-label-hide') || 'Vollständige Übersicht ausblenden';
          fullWrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } else {
          fullWrapper.setAttribute('hidden', '');
          fullToggle.textContent = fullToggle.getAttribute('data-label-show') || 'Alle Größen im Überblick anzeigen';
        }
      });
    }

    function findAgeMatch(rows, isNewborn, months) {
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        if (isNewborn) {
          if (row.getAttribute('data-age-unit') === 'new_born' ||
              (row.getAttribute('data-size-label') || '').toUpperCase() === 'NEWBORN') {
            return row;
          }
          continue;
        }
        var from = parseFloat(row.getAttribute('data-age-from-months'));
        var to = parseFloat(row.getAttribute('data-age-to-months'));
        if (isNaN(from)) from = 0;
        if (isNaN(to)) to = Infinity;
        if (months >= from && months <= to) return row;
      }
      return null;
    }

    function findMeasurementMatch(rows, value) {
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var from = parseFloat((row.getAttribute('data-length-from') || '').replace(',', '.'));
        var to = parseFloat((row.getAttribute('data-length-to') || '').replace(',', '.'));
        if (!isNaN(from) && !isNaN(to)) {
          if (value >= from && value <= to) return row;
        } else if (!isNaN(from)) {
          if (value >= from) return row;
        }
      }
      return null;
    }

    function buildCard(guideRoot, row) {
      var title = guideRoot.getAttribute('data-guide-title') || '';
      var sizeLabel = row.querySelector('.size-guide-table__size-label');
      var cells = row.querySelectorAll('td');
      var sizeText = sizeLabel ? sizeLabel.textContent.trim() : (cells[0] ? cells[0].textContent.trim() : '');
      var ageText = cells[1] ? cells[1].textContent.trim() : '';
      var measureText = cells[2] ? cells[2].textContent.trim() : '';

      var card = document.createElement('div');
      card.className = 'size-finder__result-card';

      var titleEl = '';
      if (title) {
        titleEl = '<p class="size-finder__result-title">' + title + '</p>';
      }

      card.innerHTML =
        titleEl +
        '<p class="size-finder__result-size">' + sizeText + '</p>' +
        '<p class="size-finder__result-meta">' +
          (ageText ? ageText : '') +
          (ageText && measureText ? ' &middot; ' : '') +
          (measureText ? measureText : '') +
        '</p>';
      return card;
    }

    function compute() {
      if (!resultsEl || !state.mode) return;
      resultsEl.innerHTML = '';
      var matched = 0;
      var attempted = true;

      if (state.mode === 'measurement') {
        attempted = Array.prototype.some.call(measurementInputs, function (input) {
          return input.value !== '';
        });
      }

      if (attempted) {
        guideRoots.forEach(function (guideRoot) {
          var rows = guideRoot.querySelectorAll('.size-guide-table__entry-row');
          var row = null;

          if (state.mode === 'age') {
            var isNewborn = newbornCheckbox && newbornCheckbox.checked;
            var months = ageSlider ? parseFloat(ageSlider.value) : 0;
            row = findAgeMatch(rows, isNewborn, months);
          } else if (state.mode === 'measurement') {
            var mType = guideRoot.getAttribute('data-measurement-type');
            var input = root.querySelector('[data-sf-measurement-type="' + mType + '"]');
            if (!input || !input.value) return;
            var value = parseFloat(input.value.replace(',', '.'));
            if (isNaN(value)) return;
            row = findMeasurementMatch(rows, value);
          }

          if (row) {
            matched++;
            resultsEl.appendChild(buildCard(guideRoot, row));
          }
        });
      }

      resultsEl.hidden = matched === 0;

      var emptyState = root.querySelector('[data-sf-empty]');
      if (emptyState) emptyState.hidden = !attempted || matched !== 0;
    }

    if (ageReadout && ageSlider) {
      ageReadout.textContent = monthsToLabel(ageSlider.value);
    }
  }

  function init() {
    document.querySelectorAll('[data-size-finder]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();